import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { dict } from "../i18n";

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lel_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("lel_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let cur = dict[lang] || dict.fr;
    for (const p of parts) { cur = cur?.[p]; if (cur == null) break; }
    if (cur == null) {
      let f = dict.fr;
      for (const p of parts) f = f?.[p];
      return f ?? path;
    }
    return cur;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
